var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGallery1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "gallery 1",
    clipPath: "url(#clip0_8963_37715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2652"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8963_37715",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 101,
    height: 101
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath2660"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2658",
    d: "M0.830078 0.341805H100.83V100.342H0.830078V0.341805Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8963_37715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2662"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2664",
    d: "M74.183 72.6719H10.0805C6.05039 72.6719 2.7832 69.4047 2.7832 65.3744V23.9873C2.7832 17.1539 8.32265 11.6143 15.1562 11.6143H74.183C78.2133 11.6143 81.4805 14.8814 81.4805 18.9117V65.3744C81.4805 69.4047 78.2133 72.6719 74.183 72.6719Z",
    fill: "#EE4E71"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2666"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2668",
    d: "M74.183 72.6719H10.0805C6.05039 72.6719 2.7832 69.4047 2.7832 65.3744V23.9873C2.7832 17.1539 8.32265 11.6143 15.1562 11.6143H74.183C78.2133 11.6143 81.4805 14.8814 81.4805 18.9117V65.3744C81.4805 69.4047 78.2133 72.6719 74.183 72.6719Z",
    stroke: "black",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2672",
    d: "M82.4838 80.8906H18.3812C14.351 80.8906 11.084 77.6234 11.084 73.5932V27.477C11.084 23.2555 14.5062 19.833 18.7277 19.833H82.4838C86.5141 19.833 89.7812 23.1002 89.7812 27.1305V73.5932C89.7812 77.6234 86.5141 80.8906 82.4838 80.8906Z",
    fill: "#FFD866"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2674"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2676",
    d: "M58.2451 19.833H82.484C86.5141 19.833 89.7812 23.1002 89.7812 27.1305V73.5932C89.7812 77.6234 86.5141 80.8906 82.484 80.8906H18.3814C14.3512 80.8906 11.084 77.6234 11.084 73.5932V27.477C11.084 23.2553 14.5062 19.833 18.7279 19.833H42.6201",
    stroke: "black",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2678"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2680",
    d: "M92.5277 89.0625H26.5291C23.0225 89.0625 20.1797 86.2197 20.1797 82.7131V34.3543C20.1797 30.8475 23.0225 28.0049 26.5291 28.0049H92.5277C96.0344 28.0049 98.8771 30.8475 98.8771 34.3543V82.7131C98.8771 86.2197 96.0344 89.0625 92.5277 89.0625Z",
    fill: "#D6EFFB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2682"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2684",
    d: "M92.5277 89.0625H26.5291C23.0225 89.0625 20.1797 86.2197 20.1797 82.7131V34.3543C20.1797 30.8475 23.0225 28.0049 26.5291 28.0049H92.5277C96.0344 28.0049 98.8771 30.8475 98.8771 34.3543V82.7131C98.8771 86.2197 96.0344 89.0625 92.5277 89.0625Z",
    stroke: "black",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2686"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2688",
    d: "M26.5291 89.0625H92.5277C96.0344 89.0625 98.877 86.2197 98.877 82.7131V70.2568L87.2504 61.4746C85.6322 60.2523 83.4047 60.2332 81.7656 61.4273L69.6467 70.2568L47.9699 47.9082C46.259 46.1439 43.4637 46.0354 41.6207 47.6611L20.1797 66.5775V82.7131C20.1797 86.2197 23.0223 89.0625 26.5291 89.0625Z",
    fill: "#00B7EC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2690"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2692",
    d: "M26.5291 89.0625H92.5277C96.0344 89.0625 98.877 86.2197 98.877 82.7131V70.2568L87.2504 61.4746C85.6322 60.2523 83.4047 60.2332 81.7656 61.4273L69.6467 70.2568L47.9699 47.9082C46.259 46.1439 43.4637 46.0354 41.6207 47.6611L20.1797 66.5775V82.7131C20.1797 86.2197 23.0223 89.0625 26.5291 89.0625Z",
    stroke: "black",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2694"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2696",
    d: "M57.2207 57.4463L75.6312 76.4277",
    stroke: "black",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2698"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2700",
    d: "M83.1193 46.2666C83.1193 49.8041 80.2516 52.6719 76.7141 52.6719C73.1764 52.6719 70.3086 49.8041 70.3086 46.2666C70.3086 42.7291 73.1764 39.8613 76.7141 39.8613C80.2516 39.8613 83.1193 42.7291 83.1193 46.2666Z",
    fill: "#FFD866"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2702"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2704",
    d: "M83.1193 46.2666C83.1193 49.8041 80.2516 52.6719 76.7141 52.6719C73.1764 52.6719 70.3086 49.8041 70.3086 46.2666C70.3086 42.7291 73.1764 39.8613 76.7141 39.8613C80.2516 39.8613 83.1193 42.7291 83.1193 46.2666Z",
    stroke: "black",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8963_37715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.833984 0.335938)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery1);
export default __webpack_public_path__ + "static/media/gallery_1.c2c75260bcaa6d82ba7924687301c0cd.svg";
export { ForwardRef as ReactComponent };